// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Title-module--cls1--_60lJ","cls2":"styles-Title-module--cls2--3H69g styles-Title-module--cls1--_60lJ"};